export default __webpack_public_path__ + "static/media/airplane-fuel.d360139b.jpg";